import { render, staticRenderFns } from "./DutyIndex.vue?vue&type=template&id=0063e15c&scoped=true&"
import script from "./DutyIndex.vue?vue&type=script&lang=js&"
export * from "./DutyIndex.vue?vue&type=script&lang=js&"
import style0 from "./DutyIndex.vue?vue&type=style&index=0&id=0063e15c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0063e15c",
  null
  
)

export default component.exports